import React from "react";

const CustomInput = ({
  label,
  name,
  type = "text",
  rowClass = "row-file col-lg-6 col-md-6 col-sm-12",
  ...rest
}) => (
  <div className={rowClass}>
    <label className="label">{label}</label>
    <input
      className="input input--text input-w-aux__input input--active"
      autoComplete="off"
      type={type}
      name={name}
      id={name}
      {...rest}
    />
  </div>
);

export default CustomInput;
